module.exports = __webpack_public_path__ + "static/media/greyModel.8d439542.jpg";